import React from 'react'
export function InlineElemnt(props){
    return (
        <div className={(props.className ?props.className : "")+" dis-flex item-center topM-5"} style={props.style}>
            {props.first && <div className={(props.classFirst ? props.classFirst : "")+" dis-flex"}>{props.first}</div>}
            {props.secend && <div style={props.styleSecend} className={(props.classSecend ? props.classSecend : "")+" select-non dis-flex leftM-8"}>{props.secend}</div>}
            {props.more && props.more}
        </div>
    )
}